import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import * as mapping from './language-mapping.js';
import i18nMapping from '../../../assets/i18n/profile/i18nValueMapper.json';
export type TranslateFunctionAsync = (id: string) => Observable<string>;
export type TranslateFunction = (id: string) => string;

@Injectable({
    providedIn: 'root',
})
export class I18nService {
    public map = { ...mapping };

    constructor(private translocoService: TranslocoService) {}
    public getAsync: TranslateFunctionAsync = (id) => {
        return of(this.getTranslation(id));
    };

    public get: TranslateFunction = (id) => {
        return this.getDynamicTranslation(id);
    };

    private getTranslation(id) {
        if (this.map[id]) {
            return this.map[id];
        }

        return id;
    }

    private getDynamicTranslation(id) {
        if (this.translocoService.translate(id)) {
            return this.translocoService.translate(id);
        } else if (i18nMapping && i18nMapping[id?.toString()?.trim()]) {
            const key = i18nMapping[id?.toString()?.trim()];
            if (this.translocoService.translate(key)) {
                return this.translocoService.translate(key);
            } else {
                return id;
            }
        } else if (this.map[id?.toString()?.trim()]) {
            return this.map[id];
        }

        return id;
    }
}
